import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ProjectDetails from "./pages/checklist/ProjectDetails";
import BlankLayout from "./BlankLayout";
import Dashboard from "./pages/dashboard/Dashboard";

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<BlankLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/details" element={<ProjectDetails />} />
          <Route path="/details/:hotelId" element={<ProjectDetails />} />
          <Route path="/" element={<ProjectDetails />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
